// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"1c4bfdb366a60fc1","8287":"2fa5746e266317e3","9129":"4f7e1b9d996f49bc","9645":"4f7e1b9d996f49bc"}[chunkId] + ".css";
};